











import {
  computed,
  defineComponent,
  onBeforeUnmount,
  PropType,
  ref,
  watch,
} from '@nuxtjs/composition-api';
import { IUCFeatureListSize } from '@shared/components/@organisms/UCFeatureList/types';
import useBrandConfig from '@shared/composables/useBrandConfig';
import useResponsive from '@shared/composables/useResponsive';

import FeatureListItem from './internal/FeatureListItem.vue';

const autoIncrement = (ctx: any, total: number, delayMs: number): ReturnType<typeof setInterval> =>
  setInterval(() => {
    ctx.currentIndex = ctx.currentIndex < total ? ctx.currentIndex + 1 : 0;
  }, delayMs);

export default defineComponent({
  name: 'UCFeatureList',
  components: { FeatureListItem },
  props: {
    size: {
      type: String as PropType<IUCFeatureListSize>,
      default: 'compact',
    },
    items: {
      type: Array,
      default: () => [],
    },
    iterateOnMobile: {
      type: Boolean,
      default: undefined,
    },
    delay: {
      type: Number,
      default: undefined,
    },
  },
  setup(props) {
    const { componentConfig } = useBrandConfig();
    const config = componentConfig.UCFeatureList;
    const { isMobile } = useResponsive();
    const currentIndex = ref(0);
    const timer = ref<ReturnType<typeof setInterval> | null>(null);

    const computedIterateOnMobile = computed(() =>
      props.size === 'large' ? false : config.iterateOnMobile,
    );
    const computedDelay = computed(() => config.delay);

    watch(
      isMobile,
      () => {
        if (timer.value) {
          clearInterval(timer.value as any);
          timer.value = null;
        }

        if (computedIterateOnMobile.value && props.items.length > 1 && isMobile.value) {
          timer.value = autoIncrement(this, props.items.length - 1, computedDelay.value ?? 0);
        }
      },
      { immediate: true },
    );

    onBeforeUnmount(() => {
      if (timer.value) {
        clearInterval(timer.value as any);
      }
    });

    return {
      currentIndex,
      computedIterateOnMobile,
      computedDelay,
    };
  },
});
